<template>
  <div class="upgrade-open-page pk-account-panel">
    <section class="upgrade-runner">
      <button class="back-btn" @click="$router.push({ path: '/Ornament' })">返回</button>
      <span>升级</span>
      <h1>升级</h1>
      <p>选择成功机会后使用余额尝试获得目标饰品。升级前请确认金额和成功机会。</p>

      <div class="upgrade-board">
        <div class="upgrade-side">
          <span>选择您的物品</span>
          <div class="balance-card">
            <b>使用余额</b>
            <strong>{{ costText }} <i></i></strong>
          </div>
          <div class="selected-line">
            <span>所选物品: 0/20</span>
            <strong>{{ costText }} <i></i></strong>
          </div>
        </div>

        <div class="upgrade-center">
          <div class="range-line">滚动范围: 0 - {{ moneyText(obj.price) }}</div>
          <div class="chance-dial">
            <div class="dial-core">{{ value3 }}%</div>
          </div>
          <div class="arrow-row">
            <span></span>
            <b>{{ multiplierText }}</b>
            <span></span>
          </div>
        </div>

        <div class="upgrade-side target-side">
          <span>升级</span>
          <div class="target-card">
            <img :src="obj.imageUrl" alt="" />
            <strong>{{ obj.itemName }}</strong>
          </div>
          <div class="selected-line">
            <span>商品价格</span>
            <strong>{{ moneyText(obj.price) }} <i></i></strong>
          </div>
        </div>
      </div>
    </section>

    <section class="control-panel">
      <div class="chance-control">
        <div class="control-head">
          <span>获胜机会</span>
          <strong>{{ value3 }}%</strong>
        </div>
        <el-slider v-model="value3" :show-tooltip="false" :min="5" :max="75" @change="changeNum"></el-slider>
        <div class="multiplier-row">
          <button v-for="item in multiplierList" :key="item.label" @click="setChance(item.chance)">
            {{ item.label }}
          </button>
        </div>
      </div>
      <button class="upgrade-btn" :disabled="disabled" @click="upgrade">
        <i v-if="loading" class="el-icon-loading"></i>
        升级 {{ costText }}
      </button>
      <button class="history-btn" @click="goHistory">升级记录</button>
    </section>

    <section class="roll-strip" v-show="showanim">
      <div class="roll-marker"></div>
      <div class="roll-window">
        <ul :class="{ rolling: openAnimState }">
          <li v-for="(item, index) in openAnimList" :key="index" :class="{ hit: item.name != '赠品' }">
            <img :src="item.img || item.imageUrl" alt="" />
          </li>
        </ul>
      </div>
    </section>

    <div class="result-layer" v-if="winState">
      <div class="result-card">
        <button class="close-btn" @click="winX">×</button>
        <span>{{ winFalse ? "升级成功" : "升级失败" }}</span>
        <div class="result-skin">
          <img :src="list4[0].img || list4[0].imageUrl" alt="" />
          <strong>{{ list4[0].itemName || list4[0].name }}</strong>
          <em>{{ moneyText(list4[0].price) }} <i></i></em>
        </div>
        <div class="result-actions">
          <button v-if="winFalse" @click="winexchange">兑换余额</button>
          <button @click="winget">{{ winFalse ? "放入背包" : "确认" }}</button>
        </div>
      </div>
    </div>

    <audio controls ref="notify" class="audio" loop="loop" style="display: none">
      <source src="../assets/audio/lucky.mp3" />
    </audio>
  </div>
</template>

<script>
import Utils from "../assets/js/util.js";
import { playUiSound } from "@/utils/pizzaSound";

export default {
  data() {
    return {
      openAnimState: false,
      openAnimList: [],
      disabled: false,
      winFalse: true,
      loading: false,
      value3: 25,
      list4: [],
      winState: false,
      price: 0,
      obj: {},
      noWin: {
        name: "赠品",
        price: "0.01",
        img: require("../assets/img/moneyback.png"),
        imageUrl: require("../assets/img/moneyback.png"),
      },
      showanim: true,
      multiplierList: [
        { label: "1X", chance: 75 },
        { label: "1.2X", chance: 75 },
        { label: "2X", chance: 50 },
        { label: "5X", chance: 20 },
      ],
    };
  },
  computed: {
    costText() {
      return ((Number(this.price) * this.value3) / 100).toFixed(2);
    },
    multiplierText() {
      return `${(100 / this.value3).toFixed(1)}X`;
    },
  },
  mounted() {
    this.getSkinDetail(this.$route.query.skin_id);
  },
  methods: {
    getSkinDetail(id) {
      this.$axios.post("/index/Lucky/skin_info", this.$qs.stringify({ skin_id: id })).then((res) => {
        if (res.data.status == 1) {
          this.obj = res.data.data[0];
          this.obj.img = this.obj.imageUrl;
          this.price = this.obj.price;
          this.disruptArr();
        }
      });
    },
    setChance(chance) {
      this.value3 = chance;
      this.disruptArr();
    },
    getRandomArr(arr, num) {
      const copy = arr.concat();
      const result = [];
      let n = copy.length;
      while (n-- && num--) {
        const index = Math.floor(Math.random() * n);
        [copy[index], copy[n]] = [copy[n], copy[index]];
        result.push(copy[n]);
      }
      return result;
    },
    changeNum() {
      this.disruptArr();
    },
    disruptArr() {
      if (this.loading) return;
      this.openAnimList = [];
      let numImg = parseInt((50 * this.value3) / 100);
      if (numImg < 13) {
        numImg = 13;
      }
      for (let i = 0; i < 50; i++) {
        this.openAnimList.push(i < numImg ? this.obj : this.noWin);
      }
      this.openAnimList = this.getRandomArr(this.openAnimList, 50);
      this.openAnimList[0] = this.obj;
    },
    winexchange() {
      this.$axios
        .post("/index/User/exchangeToMoneynew", this.$qs.stringify({ player_skins_ids: [this.list4[0].player_skin_id] }))
        .then((res) => {
          if (res.data.status == "1") {
            playUiSound("sale");
            this.openAnimState = false;
            this.winState = false;
            this.showanim = true;
            this.$store.commit("getMasonry", res.data.data.total_amount);
            Utils.$emit("masonry", res.data.data.total_amount);
            this.$message({ showClose: true, message: res.data.msg, type: "success" });
          }
        });
    },
    winget() {
      this.showanim = true;
      this.winState = false;
      this.openAnimState = false;
    },
    upgrade() {
      this.showanim = true;
      this.playAlarm();
      this.winState = false;
      this.loading = true;
      this.disabled = true;
      this.$axios
        .post("/index/Lucky/getSkin", this.$qs.stringify({ skin_id: this.obj.id, probability: this.value3 }))
        .then((res) => {
          const data = res.data;
          if (data.status == 1) {
            this.openAnimState = true;
            this.list4 = [];
            if (data.msg == "恭喜中奖") {
              this.$store.commit("getMoney", data.data.total_amount.toFixed(2));
              Utils.$emit("money", data.data.total_amount);
              data.data.img = data.data.imageUrl || data.data.img;
              this.openAnimList[42] = data.data;
              this.$forceUpdate();
              setTimeout(() => {
                this.loading = false;
                this.disabled = false;
                this.winFalse = true;
                this.winState = true;
                this.showanim = false;
                this.playAlarm2();
                this.list4.push(data.data);
              }, 5780);
            } else {
              this.$store.commit("getMoney", Number(data.data.total_amount.toFixed(2)) - 0.01);
              Utils.$emit("money", data.data.total_amount - 0.01);
              this.openAnimList[42] = this.noWin;
              this.$forceUpdate();
              setTimeout(() => {
                this.$store.commit("getMoney", data.data.total_amount.toFixed(2));
                Utils.$emit("money", data.data.total_amount);
                this.loading = false;
                this.disabled = false;
                this.winFalse = false;
                this.playAlarm2();
                this.list4.push(this.noWin);
                this.winState = true;
                this.showanim = false;
              }, 5780);
            }
          } else {
            this.loading = false;
            this.disabled = false;
            this.playAlarm2();
            this.$message({ message: data.msg || "升级失败", type: "warning" });
            if (data.msg == "缺少玩家信息") {
              this.$store.commit("getLogin", true);
            }
          }
        });
    },
    winX() {
      this.openAnimState = false;
      this.winState = false;
      this.showanim = true;
    },
    playAlarm() {
      this.$refs.notify.play();
    },
    playAlarm2() {
      this.$refs.notify.pause();
      this.$refs.notify.currentTime = 0.0;
    },
    goHistory() {
      this.$router.push({ path: "/OrnamentHistory", query: { skin_id: this.obj.id } });
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
  },
};
</script>

<style lang="less" scoped>
.upgrade-open-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 84% 28%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.upgrade-runner,
.control-panel,
.roll-strip {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.upgrade-runner {
  padding: 42px 34px 34px;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.back-btn {
  height: 44px;
  padding: 0 20px;
  position: absolute;
  right: 22px;
  top: 22px;
  z-index: 2;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.upgrade-runner > span,
.upgrade-side > span,
.range-line,
.control-head span,
.result-card > span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.upgrade-runner h1 {
  margin: 12px 0 14px;
  color: #f8fbff;
  font-size: 54px;
  line-height: 1;
  font-weight: 1000;
}

.upgrade-runner p {
  max-width: 720px;
  color: #aeb6c8;
  font-size: 16px;
  line-height: 1.8;
  font-weight: 800;
}

.upgrade-board {
  margin-top: 28px;
  display: grid;
  grid-template-columns: 1fr 300px 1fr;
  gap: 18px;
}

.upgrade-side,
.upgrade-center {
  min-height: 264px;
  padding: 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.balance-card,
.target-card {
  height: 150px;
  margin-top: 16px;
  display: grid;
  place-items: center;
  text-align: center;
  border-radius: 12px;
  background: radial-gradient(circle at 50% 40%, rgba(129, 73, 255, 0.24), transparent 62%), #202330;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.balance-card b,
.target-card strong {
  display: block;
  color: #f8fbff;
  font-size: 20px;
  font-weight: 1000;
}

.balance-card strong,
.selected-line strong,
.result-skin em {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffd764;
  font-size: 20px;
  font-weight: 1000;
}

.target-card img {
  max-width: 150px;
  max-height: 96px;
  object-fit: contain;
  filter: drop-shadow(0 16px 20px rgba(0, 0, 0, 0.46));
}

.selected-line {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  color: #9fa8bb;
  font-size: 13px;
  font-weight: 900;
}

.selected-line i,
.balance-card i,
.result-skin i {
  width: 17px;
  height: 17px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.upgrade-center {
  display: grid;
  place-items: center;
  text-align: center;
}

.chance-dial {
  width: 148px;
  height: 148px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background:
    conic-gradient(from 180deg, rgba(255, 138, 0, 0.92), rgba(0, 217, 255, 0.82), rgba(255, 138, 0, 0.92)),
    #202330;
  box-shadow: 0 0 46px rgba(255, 138, 0, 0.2);
}

.dial-core {
  width: 104px;
  height: 104px;
  display: grid;
  place-items: center;
  color: #f8fbff;
  background: #202330;
  border-radius: 50%;
  font-size: 28px;
  font-weight: 1000;
}

.arrow-row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #f8fbff;
  font-size: 14px;
  font-weight: 1000;
}

.arrow-row span {
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #ff8a1f);
}

.arrow-row span:last-child {
  background: linear-gradient(90deg, #ff8a1f, transparent);
}

.control-panel {
  margin-top: 22px;
  padding: 18px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 16px;
  align-items: center;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.control-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.control-head strong {
  color: #f8fbff;
  font-size: 22px;
  font-weight: 1000;
}

.multiplier-row {
  display: flex;
  gap: 8px;
}

.multiplier-row button,
.history-btn {
  height: 38px;
  padding: 0 16px;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.upgrade-btn,
.result-actions button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
}

.roll-strip {
  margin-top: 22px;
  padding: 16px 0;
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.roll-marker {
  width: 3px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  z-index: 2;
  background: #ffb11f;
  box-shadow: 0 0 24px rgba(255, 177, 31, 0.65);
}

.roll-window {
  overflow: hidden;
}

.roll-window ul {
  display: flex;
  gap: 8px;
  margin: 0;
  padding: 0 18px;
  list-style: none;
}

.roll-window li {
  width: 150px;
  min-width: 150px;
  height: 112px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: radial-gradient(circle at 50% 40%, rgba(129, 73, 255, 0.24), transparent 62%), #202330;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.roll-window li.hit {
  border-color: rgba(255, 177, 31, 0.5);
}

.roll-window img {
  max-width: 128px;
  max-height: 86px;
  object-fit: contain;
}

.rolling {
  animation: upgrade-run 5.8s ease forwards;
}

@keyframes upgrade-run {
  from { transform: translateX(0); }
  to { transform: translateX(-60%); }
}

.result-layer {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.66);
}

.result-card {
  width: min(420px, calc(100% - 32px));
  padding: 28px;
  position: relative;
  border-radius: 16px;
  background: #252836;
  border: 1px solid rgba(255, 138, 0, 0.28);
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.45);
}

.close-btn {
  width: 32px;
  height: 32px;
  position: absolute;
  right: 12px;
  top: 12px;
  color: #f4f6ff;
  background: #303342;
  border: 0;
  border-radius: 50%;
  font-size: 18px;
}

.result-skin {
  margin-top: 18px;
  display: grid;
  justify-items: center;
  gap: 10px;
  text-align: center;
}

.result-skin img {
  max-width: 220px;
  max-height: 150px;
  object-fit: contain;
  filter: drop-shadow(0 18px 24px rgba(0, 0, 0, 0.46));
}

.result-skin strong {
  color: #f8fbff;
  font-size: 20px;
  font-weight: 1000;
}

.result-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.result-actions button:last-child {
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.control-panel /deep/ .el-slider__bar {
  background: linear-gradient(90deg, #00d9ff, #ff8a00);
}

.control-panel /deep/ .el-slider__runway {
  background: #313443;
}

.control-panel /deep/ .el-slider__button {
  border-color: #ffb11f;
}

@media screen and (max-width: 1080px) {
  .upgrade-open-page {
    padding: 20px 12px 64px;
  }

  .upgrade-board,
  .control-panel {
    grid-template-columns: 1fr;
  }

  .upgrade-runner h1 {
    font-size: 46px;
  }
}
</style>

<style lang="less">
.upgrade-open-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.upgrade-open-page.pk-account-panel .upgrade-runner,
.upgrade-open-page.pk-account-panel .control-panel,
.upgrade-open-page.pk-account-panel .roll-strip {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.upgrade-open-page.pk-account-panel .upgrade-runner {
  padding: 44px 38px 38px !important;
  background:
    radial-gradient(ellipse at 50% 58%, rgba(255, 176, 55, 0.12), transparent 42%),
    radial-gradient(circle at 84% 16%, rgba(30, 211, 237, 0.13), transparent 24%),
    linear-gradient(130deg, rgba(43, 45, 60, 0.98), rgba(24, 26, 36, 0.99)) !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.upgrade-open-page.pk-account-panel .upgrade-runner h1 {
  font-size: 60px !important;
}

.upgrade-open-page.pk-account-panel .upgrade-board {
  grid-template-columns: minmax(300px, 1fr) 360px minmax(300px, 1fr) !important;
  gap: 22px !important;
}

.upgrade-open-page.pk-account-panel .upgrade-side,
.upgrade-open-page.pk-account-panel .upgrade-center {
  min-height: 330px !important;
  background:
    radial-gradient(ellipse at 50% 56%, rgba(255, 132, 31, 0.08), transparent 58%),
    rgba(255, 255, 255, 0.035) !important;
  border-color: rgba(111, 121, 151, 0.24) !important;
}

.upgrade-open-page.pk-account-panel .balance-card,
.upgrade-open-page.pk-account-panel .target-card {
  height: 184px !important;
  background:
    radial-gradient(circle at 50% 44%, rgba(255, 132, 31, 0.15), transparent 62%),
    radial-gradient(circle at 50% 42%, rgba(129, 73, 255, 0.26), transparent 64%),
    #202330 !important;
  border-color: rgba(111, 121, 151, 0.26) !important;
}

.upgrade-open-page.pk-account-panel .target-card img {
  max-width: 194px !important;
  max-height: 126px !important;
}

.upgrade-open-page.pk-account-panel .chance-dial {
  width: 178px !important;
  height: 178px !important;
  box-shadow:
    0 0 54px rgba(255, 138, 0, 0.24),
    0 0 36px rgba(0, 217, 255, 0.14) !important;
}

.upgrade-open-page.pk-account-panel .dial-core {
  width: 122px !important;
  height: 122px !important;
  font-size: 32px !important;
}

.upgrade-open-page.pk-account-panel .control-panel {
  grid-template-columns: 1fr 180px 140px !important;
  padding: 20px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.upgrade-open-page.pk-account-panel .roll-strip {
  height: 158px !important;
  border-color: rgba(255, 132, 31, 0.22) !important;
  box-shadow: inset 0 1px 0 rgba(255, 224, 170, 0.05) !important;
}

.upgrade-open-page.pk-account-panel .roll-window li {
  width: 180px !important;
  min-width: 180px !important;
  height: 126px !important;
}

.upgrade-open-page.pk-account-panel .roll-window img {
  max-width: 154px !important;
  max-height: 98px !important;
}

@media screen and (max-width: 1080px) {
  .upgrade-open-page.pk-account-panel {
    padding: 20px 12px 72px !important;
  }

  .upgrade-open-page.pk-account-panel .upgrade-runner,
  .upgrade-open-page.pk-account-panel .control-panel,
  .upgrade-open-page.pk-account-panel .roll-strip {
    width: 100% !important;
    max-width: 100% !important;
  }

  .upgrade-open-page.pk-account-panel .upgrade-board,
  .upgrade-open-page.pk-account-panel .control-panel {
    grid-template-columns: 1fr !important;
  }
}
</style>
